import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RELEASE } from '../../release';
import { useAuth } from '../../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// Staff-only: which release the browser and the server are running
export const ReleaseBadge = ({ collapsed }) => {
  const { token } = useAuth();
  const [srv, setSrv] = useState(null);
  const check = () => {
    axios.get(`${API}/api/admin/release`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setSrv(r.data)).catch(() => setSrv({ error: true }));
  };
  useEffect(check, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  if (collapsed) return null;
  const mismatch = srv?.version && srv.version !== RELEASE.version;
  return (
    <button type="button" onClick={check} title="Check live release" className="w-full text-left px-3 py-2 border-t border-neutral-200 text-[10px] text-neutral-400 hover:text-neutral-700" data-testid="admin-release-badge">
      <span data-testid="admin-release-version">Release {RELEASE.version}</span>
      {srv?.deployed_at && <span className="block" data-testid="admin-release-deployed">Server {srv.version} · {new Date(srv.deployed_at).toLocaleString()}</span>}
      {mismatch && <span className="block text-red-600" data-testid="admin-release-mismatch">Browser and server releases differ: refresh the page</span>}
    </button>
  );
};
